import { useEffect, useRef, useState } from "react";
import "../../lib/form/form.scss";
import "./Signup.scss";
import { MdOutlineRememberMe, MdCheckBox } from "react-icons/md";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { Outlet, useNavigate } from "react-router-dom";
function Signup() {
  let navigate = useNavigate();
  // const heighL = useRef();
  // const btnWidth = useRef();
  // useEffect(() => {
  //   heighL.current.style.width = btnWidth.current.offsetWidth + "px";
  //   heighL.current.style.height = btnWidth.current.offsetHeight + "px";
  // });

  // function sliding(val) {
  //   heighL.current.style.left = val + "px";
  // }

  return (
    <>
      <h1
        style={{
          textAlign: "center",
          color: "white",
          fontSize: "1.5rem",
          marginTop: "3rem",
        }}
      >
        회원가입
      </h1>
      <div className="tab_btns_wrap login_tab_wrap login_tab_wrap_div">
        <div className="tab_btns login_tab">
          <div
            className="login_tab_inner"
            onClick={() => {
              navigate("/usersignup");
            }}
          >
            <div className="login_tab_icon">
              <HiOutlineOfficeBuilding />
            </div>
            <div className="tabBtn tabBtn_div">
              신청기관
              <br />
              회원가입
            </div>
          </div>
          <div
            className="login_tab_inner"
            onClick={() => {
              navigate("/committeesignup");
            }}
          >
            <div className="login_tab_icon">
              <MdOutlineRememberMe />
            </div>
            <div className="tabBtn tabBtn_div">
              위원회
              <br />
              회원가입
            </div>
          </div>
        </div>
        {/* <span ref={heighL} className="slidebar"></span> */}
      </div>
    </>
  );
}
export default Signup;
